export const PRICING_FUNCTIONS = {
  left: [
    'Facturation électronique',
    'Tableau de bord (MYzLawyer)',
    'Gestion des profils utilisateurs',
    'Gestions des dossiers',
    'Gestion documentaire',
    'Facturation au temps passe / forfait / provisions',
    'Modeles personnalisables',
    'Suivi du reste a facturer par dossier',
    'Tableaux de bords financiers',
  ],
  right: [
    'Reportings et statistiques',
    'Suivi des performances',
    'Exports comptables',
    'Relance des impayes',
    'Gestion des emails',
    'Application mobile',
    'Tamponnage numérique',
    'Rapprochement bancaire',
    'Intelligence artificielle Zephyr',
  ],
};
